import { jsx as l } from "react/jsx-runtime";
const c = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-9.642-2.618a477 477 0 0 0-5.832 2.513q-.71.282-.744.552c-.038.304.343.424.862.587l.22.07c.51.166 1.196.36 1.554.368q.485.01 1.084-.4 4.086-2.76 4.218-2.789c.062-.014.149-.032.207.02.059.052.053.15.047.177-.038.161-1.534 1.552-2.308 2.271-.242.225-.413.384-.448.42q-.118.123-.235.233c-.474.457-.83.8.02 1.36.408.27.735.492 1.06.714.357.242.712.484 1.172.785q.175.116.337.234c.415.296.787.56 1.247.519.267-.025.543-.276.683-1.026.331-1.77.982-5.608 1.133-7.19a1.8 1.8 0 0 0-.017-.393.42.42 0 0 0-.142-.27c-.12-.098-.305-.118-.388-.117-.376.007-.953.207-3.73 1.362",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  c as default
};
